var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"options":_vm.cascaderOptions,"disabled":_vm.disabled,"show-all-levels":_vm.data.setting.showAllLevels,"collapse-tags":_vm.data.setting.collapseTags,"props":{
					checkStrictly: _vm.data.setting.checkStrictly,
					multiple: _vm.data.setting.multiple 
				 }},on:{"change":_vm.cascaderChange},model:{value:(_vm.model[_vm.data.fieldId]),callback:function ($$v) {_vm.$set(_vm.model, _vm.data.fieldId, $$v)},expression:"model[data.fieldId]"}})
}
var staticRenderFns = []

export { render, staticRenderFns }